module.exports = __webpack_public_path__ + "static/media/loads.cfa63932.svg";